import styles from "../styles/GreenMagProView.module.css";

const GreenMagProView = () => {
  return (
    <div className={styles.container}>
      <h2>GreenMag Pro</h2>
      <p>Продвинутые инструменты и функции для пользователей GreenMag Pro.</p>
    </div>
  );
};

export default GreenMagProView;
